import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';

import styles from './styles.module.scss';

type Props = {
  children: JSX.Element;
  title: string;
  isOpen: boolean;
  onClick: () => void;
} & BaseComponentProps;

const ExpandableSection = (props: Props) => {
  const {
    title,
    isOpen,
    onClick,
    children,
    theme = 'light',
    containerStyle,
  } = props;

  return (
    <div
      className={clsx([
        styles.expandableSection,
        isOpen && styles.open,
        containerStyle,
      ])}
    >
      <h5
        className={clsx([styles.expandableSection__title, styles[theme]])}
        onClick={onClick}
      >
        {title}
      </h5>
      <div className={styles.expandableSection__content}>{children}</div>
    </div>
  );
};

export default ExpandableSection;
